var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        "custom-class": "expriate-modal",
        center: "",
        "append-to-body": "",
        visible: _vm.expriateVisible,
        width: "380px",
        "before-close": _vm.hideModal
      },
      on: {
        "update:visible": function($event) {
          _vm.expriateVisible = $event
        }
      }
    },
    [
      _c(
        "div",
        {
          staticClass: "dialog-title",
          attrs: { slot: "title" },
          slot: "title"
        },
        [_c("div", { staticClass: "title" }, [_vm._v("温馨提示")])]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "expriate-modal-txt" }, [
        _vm._v("\n    尊敬的用户，您签署的连连钱袋"),
        _c("a", [_vm._v("《免密免验代发协议》")]),
        _vm._v(
          "\n    " +
            _vm._s(_vm.htmlTxt === "EXPIRED" ? "已过期" : "即将到期") +
            "，过期后您的提现功能将受影响。\n    "
        ),
        _c("br"),
        _vm._v("\n    为了不影响您的提现，请尽快续签。\n  ")
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "flex-row-center-center" },
        [
          _c(
            "el-button",
            {
              staticClass: "sign-btn",
              attrs: { type: "primary" },
              on: { click: _vm.goSign }
            },
            [_vm._v("去签约")]
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7cecc8d6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7cecc8d6","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/purseSetting/withdrawal/components/expriateModal.vue
// module id = null
// module chunks = 